// === Get URL parameters like your original getUrlVars() ===
function getUrlVars() {
    const vars = {};
    const queryString = window.location.href.split('?')[1] || '';
    const pairs = queryString.split('&').filter(Boolean);

    for (const item of pairs) {
        const [key, value] = item.split('=');
        vars[key] = value;
    }

    return vars;
}

// === GA Tracking Helpers ===
function TrackGA(event, params) {
    gtag('event', event, params);
}

// The theme's own gtag config (snippets/analytics.liquid) is for G-285995344,
// which is a property number with "G-" in front, not a real measurement ID, so
// TrackGA hits sent after load land nowhere. The real GA4 property, "Wellow
// Website - GA4", is G-RJFJGM7P5E (loaded by GTM and the Google app). New
// events are sent there explicitly with send_to; existing TrackGA events are
// left as they are until that config is fixed.
const GA4_MEASUREMENT_ID = 'G-RJFJGM7P5E';

// Analytics loads late (snippets/analytics.liquid waits for the first
// interaction or 3s), and a gtag event aimed at G-RJFJGM7P5E before that tag
// is configured is dropped, not queued. Events fired that early — like the
// ?ps_ap=1 auto-select, which runs on page load — wait here until the tag
// registers itself on window.google_tag_manager, then go out in order. If it
// never loads (e.g. no consent), they are dropped after 20s, as any hit would be.
const ga4Pending = [];
let ga4WaitTimer = null;

function ga4Ready() {
    return !!(window.google_tag_manager && window.google_tag_manager[GA4_MEASUREMENT_ID]);
}

function sendGA4(event, params) {
    gtag('event', event, Object.assign({ send_to: GA4_MEASUREMENT_ID }, params));
}

function TrackGA4(event, params) {
    if (ga4Ready()) {
        sendGA4(event, params);
        return;
    }
    ga4Pending.push([event, params]);
    if (ga4WaitTimer) return;
    const startedAt = Date.now();
    ga4WaitTimer = setInterval(function () {
        const ready = ga4Ready();
        if (!ready && Date.now() - startedAt < 20000) return;
        clearInterval(ga4WaitTimer);
        ga4WaitTimer = null;
        const queued = ga4Pending.splice(0, ga4Pending.length);
        if (ready) queued.forEach(function (item) { sendGA4(item[0], item[1]); });
    }, 250);
}

// === PDP switcher usage flags ===
// A first-party cookie, "wl_switchers", records whether the shopper has used
// the fabric switcher ("f") and/or the support-level switcher ("s") — e.g.
// "fs". It is a cookie rather than sessionStorage so the "Google Purchase
// conversion" custom pixel can read it on checkout_completed (via
// browser.cookie.get) and send it with the order; that pixel clears it after
// the purchase. 7 days, so "used a switcher" means within a week of buying.
const SWITCHER_COOKIE = 'wl_switchers';
const SWITCHER_COOKIE_MAX_AGE = 7 * 24 * 60 * 60;

function readSwitcherFlags() {
    const match = document.cookie.match(/(?:^|;\s*)wl_switchers=([^;]*)/);
    const value = match ? decodeURIComponent(match[1]) : '';
    return { fabric: value.indexOf('f') !== -1, support: value.indexOf('s') !== -1 };
}

function markSwitcherUsed(axis) {
    const flags = readSwitcherFlags();
    flags[axis] = true;
    const value = (flags.fabric ? 'f' : '') + (flags.support ? 's' : '');
    document.cookie = SWITCHER_COOKIE + '=' + value + '; path=/; max-age=' + SWITCHER_COOKIE_MAX_AGE + '; SameSite=Lax';

    // Also save the flag on the cart so it carries through to the order, where
    // the "Google Purchase conversion" pixel reads it. The leading underscore
    // hides the attribute from shoppers; /cart/update.js merges attributes, so
    // existing ones (e.g. shipping_threshold_abtest) are left alone.
    const attrKey = axis === 'fabric' ? '_used_fabric_switcher' : '_used_support_switcher';
    try {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { [attrKey]: 'true' } })
        }).catch(function () {});
    } catch (e) {}
}

// GA4 parameters, as strings so they register as text custom dimensions.
function switcherFlagParams() {
    const flags = readSwitcherFlags();
    return {
        used_fabric_switcher: flags.fabric ? 'true' : 'false',
        used_support_switcher: flags.support ? 'true' : 'false',
    };
}

function TrackSoldOut(el) {
    const element = el ?? document.querySelector('input.SizeSwatch__Radio:not(.PackSwatch__Radio)');
    if (!element) return;

    const label = element.getAttribute('data-product-title');

    setTimeout(() => {
        const addToCartButton = document.querySelector('.ProductForm__AddToCart');
        if (addToCartButton && addToCartButton.disabled) {
            TrackGA('SoldOut_event', { label, action: element.value });
        }
    }, 500);
}

// === EVENT DELEGATION ===
document.addEventListener('click', function (e) {

    const target = e.target;

    // Shop now - Summer Banner
    if (target.matches('.summer-banner .shop-btn1')) {
        TrackGA('homeBanner_btn_click', { label: 'Shop-SummerStripe' });
    }

    // Shop now - Regular Banner
    if (target.matches('.regular-banner .shop-btn1')) {
        TrackGA('homeBanner_btn_click', { label: 'Shop-men-banner' });
    }

    if (target.matches('.regular-banner .shop-btn2')) {
        TrackGA('homeBanner_btn_click', { label: 'Shop-women-banner' });
    }

    // Size Chart Click
    if (target.matches('.SizeChartButton')) {
        const label = target.getAttribute('data-product-title');
        TrackGA('size_chart_click', { label });
    }

    // Collection Filter
    if (target.matches('.collection-filter a')) {
        const label = target.getAttribute('data-collection-name');
        const action = target.getAttribute('data-value');
        TrackGA('collection_filter_click', { label, action });
    }

    // Desktop Navigation (normal and gold)
    if (target.matches('body:not(.gold-member-active) .ga-track-desktop')) {
        TrackGA('desktop_navigation_click', {
            label: target.getAttribute('data-ga-label'),
            action: 'click',
            media: 'desktop'
        });
    }
    if (target.matches('body.gold-member-active .ga-track-desktop')) {
        TrackGA('gold_desktop_navigation_click', {
            label: target.getAttribute('data-ga-label'),
            action: 'click',
            media: 'desktop'
        });
    }

    // Mobile Navigation (normal and gold)
    if (target.matches('body:not(.gold-member-active) .ga-track-mobile')) {
        TrackGA('mobile_navigation_click', {
            label: target.getAttribute('data-ga-label'),
            action: 'click',
            media: 'mobile'
        });
    }
    if (target.matches('body.gold-member-active .ga-track-mobile')) {
        TrackGA('gold_mobile_navigation_click', {
            label: target.getAttribute('data-ga-label'),
            action: 'click',
            media: 'mobile'
        });
    }

    // Gold Status Buttons
    if (target.matches('body.template-page.gold-member-active button.checkGoldMember')) {
        TrackGA('gold_status_check_click', {
            label: 'Gold status check',
            action: 'click',
            user_type: 'Gold',
            page: 'Landing'
        });
    }
    if (target.matches('body.template-page:not(.gold-member-active) button.checkGoldMember')) {
        TrackGA('gold_status_check_click', {
            label: 'Gold status check',
            action: 'click',
            user_type: 'Non-Gold',
            page: 'Landing'
        });
    }
    if (target.matches('body.template-page.gold-member-active button#GoldStatusBtn')) {
        TrackGA('gold_status_check_submit', {
            label: 'Gold status check',
            action: 'submit',
            user_type: 'Gold',
            page: 'Landing'
        });
    }
    if (target.matches('body.template-page:not(.gold-member-active) button#GoldStatusBtn')) {
        TrackGA('gold_status_check_submit', {
            label: 'Gold status check',
            action: 'submit',
            user_type: 'Non-Gold',
            page: 'Landing'
        });
    }

    if (target.matches('body.template-product.gold-member-active button.checkGoldMember')) {
        TrackGA('gold_status_check_pdp_click', {
            label: 'Gold status check',
            action: 'click',
            user_type: 'Gold',
            page: 'PDP'
        });
    }
    if (target.matches('body.template-product:not(.gold-member-active) button.checkGoldMember')) {
        TrackGA('gold_status_check_pdp_click', {
            label: 'Gold status check',
            action: 'click',
            user_type: 'Non-Gold',
            page: 'PDP'
        });
    }
    if (target.matches('body.template-product.gold-member-active button#GoldStatusBtn')) {
        TrackGA('gold_status_pdp_check_submit', {
            label: 'Gold status check',
            action: 'submit',
            user_type: 'Gold',
            page: 'PDP'
        });
    }
    if (target.matches('body.template-product:not(.gold-member-active) button#GoldStatusBtn')) {
        TrackGA('gold_status_check_pdp_submit', {
            label: 'Gold status check',
            action: 'submit',
            user_type: 'Non-Gold',
            page: 'PDP'
        });
    }

    // Generic BYOB track
    if (target.matches('[data-ga-track]')) {
        try {
            const gaOptions = JSON.parse(target.getAttribute('data-ga-options'));
            const page = gaOptions.page;

            const trackingData = {
                label: gaOptions.label,
                page: page,
                action: 'click'
            };

            if (gaOptions.collection) trackingData.collection = gaOptions.collection;
            if (gaOptions.product) trackingData.product = gaOptions.product;
            if (gaOptions.cart) trackingData.cart = gaOptions.cart;

            TrackGA('byob_merchandizing_link_click_' + page.toLowerCase(), trackingData);
        } catch (error) {}
    }

});

// Color Swatch Change
document.addEventListener('change', function (e) {
    const target = e.target;

    if (target.matches('.color-dot-col [type="radio"]')) {
        const label = target.getAttribute('data-product-title');
        const parts = target.name.split('-');
        let action = '1-Pack';

        if (parts[1] == '3') action = '3-Pack';
        else if (parts[1] == '5') action = '5-Pack';
        else if (parts[1] == '6') action = '6-Pack';

        TrackGA('color_swatch_click', { label, action });
    }

    if (target.matches('input.SizeSwatch__Radio:not(.PackSwatch__Radio)')) {
        const label = target.getAttribute('data-product-title');
        TrackGA('size_swatch_click', {
            label,
            action: target.value
        });
        TrackSoldOut(target);
    }

    if (target.matches('input.PackSwatch__Radio')) {
        const label = target.getAttribute('data-product-title');
        TrackGA('pack_swatch_click', {
            label,
            action: 'click',
            pack: target.value
        });
        TrackSoldOut(target);
    }

    if (target.matches('.FabricSwatch__Radio.js-fabric-switch-radio')) {
        const checkedColorDot = document.querySelector('.color-dot-col input[type="radio"]:checked');
        const checkedSize = document.querySelector('input.SizeSwatch__Radio:not(.PackSwatch__Radio):checked');
        const checkedPack = document.querySelector('input.PackSwatch__Radio:checked');

        const eventModel = {
            color: checkedColorDot ? checkedColorDot.getAttribute('data-product-title') : undefined,
            size: checkedSize ? checkedSize.value : undefined,
            handle: checkedColorDot ? checkedColorDot.getAttribute('data-product-handle') : undefined
        };
        if (checkedPack) {
            eventModel.pack = checkedPack.value
                .split('_')
                .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
                .join(' ');
        }

        TrackGA('fabric_swatch_click', eventModel);
    }
});

// === PDP fabric / support-level switcher events ===
// Capture phase on purpose: the switchers' own change handlers (snippets/
// js-variables.liquid) overwrite the container's current fabric / level the
// moment they run, so the "from" value has to be read before they do. Capture
// listeners on document run before any listener on the radio itself.
//
// source says what selected the radio: "card" (the shopper), "compare_modal"
// (a pick button in the Compare modal) or "ab_autoselect" (the ?ps_ap=1 test
// pre-selecting Aerolite+). Programmatic selections tag the radio with
// data-track-source before clicking it. The A/B auto-select is not a shopper
// choice, so it is reported but does not set the "used switcher" flag.
function switcherSource(radio) {
    const source = radio.dataset.trackSource || 'card';
    delete radio.dataset.trackSource;
    return source;
}

function currentProductContext(container) {
    // Scoped to the main product section: recommended cards further down the
    // page can carry their own colour dots.
    const scope = document.querySelector('[data-section="product-data-section"]') || document;
    const checkedDot = scope.querySelector('.color-dot-col input[type="radio"]:checked');
    return {
        product_id: container.dataset.productId,
        product_handle: checkedDot ? checkedDot.getAttribute('data-product-handle') : undefined,
    };
}

// GA4 values use underscores: aerolite_plus, extra_firm.
function gaValue(handle) {
    return handle ? String(handle).replace(/-/g, '_') : undefined;
}

document.addEventListener('change', function (e) {
    const target = e.target;

    if (target.matches('.FabricSwatch__Radio.js-fabric-switch-radio')) {
        const container = target.closest('.fabric-technology-section');
        const label = container && container.querySelector('label[for="' + target.id + '"]');
        if (!container || !label) return;
        const from = container.dataset.fabricHandle;
        const to = label.dataset.fabricHandle;
        if (!to || from === to) return;
        const source = switcherSource(target);
        if (source !== 'ab_autoselect') markSwitcherUsed('fabric');
        TrackGA4('fabric_option_select', Object.assign({
            from_fabric: gaValue(from),
            to_fabric: gaValue(to),
            source: source,
        }, currentProductContext(container)));
    }

    if (target.matches('.SupportSwatch__Radio.js-support-switch-radio')) {
        const container = target.closest('.support-level-section');
        if (!container) return;
        const from = container.dataset.currentSupportLevel;
        const to = target.dataset.supportLevel;
        if (!to || from === to) return;
        const source = switcherSource(target);
        if (source !== 'ab_autoselect') markSwitcherUsed('support');
        TrackGA4('support_level_select', Object.assign({
            from_level: gaValue(from),
            to_level: gaValue(to),
            source: source,
        }, currentProductContext(container)));
    }
}, true);

// Klaviyo forms
window.addEventListener('klaviyoForms', function (event) {
    if (event.detail.type === 'submit' && event.detail.formId === 'QYv6uw') {
        try {
            fbq("track", "CompleteRegistration");
        } catch (error) {}
    }
});

// Sold out on load
TrackSoldOut();

// Apply URL class from query
const banner = getUrlVars()['ab'];
if (banner !== undefined) {
    document.body.classList.add(banner);
}

// Additional URL param logic
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('banner') === 'ab-slide-active') {
    document.body.classList.add('ab-slide-active');
}

// === Order-level discount badge renderer ===
// Parses discount function titles like "LASTCHANCE 35% -$104.96 GOLD 5% -$24.74"
// and renders each individual discount as a separate badge.
(function () {
    function parseOrderDiscountBadges(scope) {
        let target = scope || document;
        target.querySelectorAll('.Cart__Discount--order-level[data-discount-title]').forEach(function (container) {
            if (container.querySelector('.Cart__Discount--badge')) return;
            let title = container.dataset?.discountTitle || '';
            let regex = /([^\s]+)\s+(\d+(?:\.\d+)?%)\s+(-\$[\d,]+(?:\.\d+)?)/gi;
            let badges = [];
            let match;
            while ((match = regex.exec(title)) !== null) {
                badges.push({ code: match[1], pct: match[2], amount: match[3] });
            }
            if (badges.length > 0) {
                container.innerHTML = badges.map(function (b) {
                    return '<span class="CartItem__Discount Cart__Discount--badge">' + b.code + ' ' + b.pct + ' ' + b.amount + '</span>';
                }).join('');
            } else if (title) {
                let total = container.dataset?.discountTotal || '';
                container.innerHTML = '<span class="CartItem__Discount Cart__Discount--badge">' + title + (total ? ': -' + total : '') + '</span>';
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        parseOrderDiscountBadges();
        let debounceTimer;
        let observer = new MutationObserver(function () {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(parseOrderDiscountBadges, 50);
        });
        observer.observe(document.body, { childList: true, subtree: true });
    });
})();

(function () {
    const LIST_TTL = 30 * 60 * 1000; // 30 minutes

    // name is optional: collection lists use the handle for both id and name
    // (GA4's convention here); the PDP recommendations list has a display name.
    function rememberList(itemId, handle, index, variant, name) {
      let map = {};
      try { map = JSON.parse(sessionStorage.getItem('wellow_list_ctx') || '{}'); } catch (e) {}
      map[itemId] = { handle, name, index, variant, ts: Date.now() };
      sessionStorage.setItem('wellow_list_ctx', JSON.stringify(map));

      // The same list context as a cookie, so the checkout pixel can read which
      // list each purchased product was clicked from. Format:
      // { "<productId>": ["<list name>", <timestamp ms>] }, newest 20 kept.
      try {
        let ctx = {};
        try {
          const match = document.cookie.match(/(?:^|;\s*)wl_list_ctx=([^;]*)/);
          ctx = match ? JSON.parse(decodeURIComponent(match[1])) : {};
          if (!ctx || typeof ctx !== 'object' || Array.isArray(ctx)) ctx = {};
        } catch (e) { ctx = {}; }
        ctx[String(itemId)] = [name || handle, Date.now()];
        const newest = Object.keys(ctx)
          .sort(function (a, b) { return ((ctx[b] && ctx[b][1]) || 0) - ((ctx[a] && ctx[a][1]) || 0); })
          .slice(0, 20);
        const trimmed = {};
        newest.forEach(function (key) { trimmed[key] = ctx[key]; });
        document.cookie = 'wl_list_ctx=' + encodeURIComponent(JSON.stringify(trimmed)) + '; path=/; max-age=' + (7 * 24 * 60 * 60) + '; SameSite=Lax';
      } catch (e) {}
    }

    function recallList(itemId) {
        try {
          const map = JSON.parse(sessionStorage.getItem('wellow_list_ctx') || '{}');
          const e = map[itemId];
          if (e && (Date.now() - e.ts) < LIST_TTL) return e;
        } catch (e) {}
        return null; // no collection drove this add
    }

    // Two kinds of product list share the impression / click tracking below:
    // collection grids (cards are .product-col) and the PDP "You may also like"
    // carousel (cards are .Carousel__Cell, tagged with data-product-id in
    // sections/product-recommendations.liquid).
    const LIST_SECTION_SELECTOR =
        'section[data-section-type="collection"][data-collection-handle], section[data-section-type="product-recommendations"]';
    const RECOMMENDED_LIST = { id: 'pdp-recommended', name: 'PDP Recommended' };

    function isRecommendations(section) {
        return section.dataset.sectionType === 'product-recommendations';
    }

    function cardSelector(section) {
        return isRecommendations(section) ? '.Carousel__Cell[data-product-id]' : '.product-col';
    }

    function listMeta(section) {
        if (isRecommendations(section)) return RECOMMENDED_LIST;
        return { id: section.dataset.collectionHandle, name: section.dataset.collectionHandle };
    }

    function visibleCards(section) {
        return Array.from(section.querySelectorAll(cardSelector(section))).filter(
            (col) => col.offsetParent !== null
        );
    }

    // Re-checked at dwell-guard time to confirm a card is *still* in the viewport
    // (not just `display`-visible) — offsetParent alone can't tell a card that's
    // still on the page but scrolled away from one that's actually on screen.
    function isSubstantiallyVisible(el) {
        const rect = el.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return false;
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const vw = window.innerWidth || document.documentElement.clientWidth;
        const visibleHeight = Math.min(rect.bottom, vh) - Math.max(rect.top, 0);
        const visibleWidth = Math.min(rect.right, vw) - Math.max(rect.left, 0);
        if (visibleHeight <= 0 || visibleWidth <= 0) return false;
        return (visibleHeight * visibleWidth) / (rect.width * rect.height) >= 0.5;
    }

    function slotIndex(section, card) {
        return visibleCards(section).indexOf(card) + 1;
    }

    function activeColorway(card) {
        const checked = card.querySelector('.color-dot-col input:checked');
        if (checked) {
            return { item_id: checked.dataset.productId, item_variant: checked.dataset.productTitle };
        }
        // No swatch is marked :checked (main-collection.liquid's `.product-col` never
        // carries data-product-id itself, unlike no-grouping-collection.liquid's flat
        // cards) — fall back to the first rendered swatch, which is the group's
        // intended default colorway, rather than falling through to an attribute that
        // doesn't exist on this template and silently resolving to undefined.
        const firstDot = card.querySelector('.color-dot-col input');
        if (firstDot) {
            return { item_id: firstDot.dataset.productId, item_variant: firstDot.dataset.productTitle };
        }
        return { item_id: card.dataset.productId, item_variant: card.dataset.productTitle };
    }

    function listSections() {
        return document.querySelectorAll(LIST_SECTION_SELECTOR);
    }

    const seenCards = new WeakSet();
    const buffers = new WeakMap(); // section -> { items, timer }

    function flush(section) {
        const buf = buffers.get(section);
        if (!buf || !buf.items.length) return;
        const list = listMeta(section);
        // PDP Recommended is new tracking, so it goes to the real property;
        // collection lists keep their existing destination.
        const track = isRecommendations(section) ? TrackGA4 : TrackGA;
        track('view_item_list',{
            item_list_id: list.id,
            item_list_name: list.name,
            items: buf.items.splice(0, buf.items.length)
        });
    }

    const impressionObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const card = entry.target;
                if (seenCards.has(card)) return;
                setTimeout(() => {
                    // Re-check real viewport geometry, not just isIntersecting from the
                    // original callback — a fast/instant scroll can deliver entries for
                    // cards that only transiently crossed the threshold and are no longer
                    // on screen by the time the dwell guard runs. Leave those still
                    // observed (don't mark seen / unobserve) so they're picked up
                    // correctly the next time they actually enter the viewport.
                    if (!card.isConnected || !isSubstantiallyVisible(card)) return;
                    if (seenCards.has(card)) return;
                    seenCards.add(card);
                    const section = card.closest(LIST_SECTION_SELECTOR);
                    if (!section) return;
                    const { item_id, item_variant } = activeColorway(card);
                    if (!buffers.has(section)) buffers.set(section, { items: [], timer: null });
                    const buf = buffers.get(section);
                    buf.items.push({ item_id, item_variant, index: slotIndex(section, card) });
                    impressionObserver.unobserve(card);
                    if (buf.items.length >= 20) {
                        clearTimeout(buf.timer);
                        buf.timer = null;
                        flush(section);
                    } else if (!buf.timer) {
                        // Arm the flush only when the buffer goes empty -> non-empty, so a
                        // steady scroll (new cards confirming faster than every 500ms) still
                        // flushes on a fixed ~500ms cadence instead of the timer being pushed
                        // back by every new card and never firing until scrolling stops.
                        buf.timer = setTimeout(() => {
                            buf.timer = null;
                            flush(section);
                        }, 500);
                    }
                }, 400);
            });
        },
        { threshold: 0.5 }
    );

    function observeNewCards() {
        listSections().forEach((section) => {
            section.querySelectorAll(cardSelector(section)).forEach((card) => {
                if (!card.dataset.wellowObserved) {
                    card.dataset.wellowObserved = 'true';
                    impressionObserver.observe(card);
                }
            });
        });
    }

    document.addEventListener('DOMContentLoaded', observeNewCards);
    // product-recommendations:loaded — the carousel is fetched after load, and
    // re-fetched for the new product after a fabric / support-level swap.
    ['products:grouped', 'products:page-loaded', 'products:all-loaded', 'product-recommendations:loaded'].forEach((evt) =>
        document.addEventListener(evt, observeNewCards)
    );

    // --- wellow_select_item: click-through to PDP ---
    document.addEventListener('click', function (e) {
        const link = e.target.closest('a.product-url');
        if (!link) return;
        const section = link.closest('section[data-section-type="collection"][data-collection-handle]');
        if (!section) return;
        const card = link.closest('.product-col');
        if (!card) return;
        const { item_id, item_variant } = activeColorway(card);

        rememberList(item_id, section.dataset.collectionHandle, slotIndex(section, card), item_variant);

        TrackGA('select_item',{
            item_list_id: section.dataset.collectionHandle,
            item_list_name: section.dataset.collectionHandle,
            items: [{ item_id, item_variant, index: slotIndex(section, card) }],
        });
    });

    // --- select_item: click-through from the PDP "You may also like" carousel ---
    // Any link to the product inside a recommended card (image or title).
    // rememberList lets the add_to_cart below attribute the add to this list.
    document.addEventListener('click', function (e) {
        const link = e.target.closest('a[href*="/products/"]');
        if (!link) return;
        const section = link.closest('section[data-section-type="product-recommendations"]');
        if (!section) return;
        const card = link.closest('.Carousel__Cell[data-product-id]');
        if (!card) return;
        const { item_id, item_variant } = activeColorway(card);
        const index = slotIndex(section, card) || undefined;

        rememberList(item_id, RECOMMENDED_LIST.id, index, item_variant, RECOMMENDED_LIST.name);

        TrackGA4('select_item', {
            item_list_id: RECOMMENDED_LIST.id,
            item_list_name: RECOMMENDED_LIST.name,
            items: [{ item_id, item_variant, index }],
        });
    });

    // --- wellow_select_swatch: color-dot click (main-collection only) ---
    document.addEventListener('click', function (e) {
        const dot = e.target.closest('.color-dot-col');
        if (!dot) return;
        const section = dot.closest('section[data-section-type="collection"][data-collection-handle]');
        if (!section) return;
        const input = dot.querySelector('input');
        if (!input) return;
        const swatchIndex = Array.from(dot.parentElement.children).indexOf(dot) + 1;
        TrackGA('select_swatch',{
            item_id: input.dataset.productId,
            item_name: input.dataset.productTitle,
            index: slotIndex(section, dot.closest('.product-col')),
            swatch_index: swatchIndex,
            item_list_id: section.dataset.collectionHandle,
            item_list_name: section.dataset.collectionHandle,
            color_selected: input.dataset.productHandle,
        });
    });

    // --- add_to_cart: fires on every successful add (theme's "product:added" event),
    // carrying item_list_name/index recalled from the collection card that was clicked,
    // if the add happened within LIST_TTL of that click. No recalled list -> those fields
    // are simply omitted (direct-to-PDP adds correctly show no list attribution). ---
    document.addEventListener('product:added', function (e) {
        const { product, variant, quantity, addSource, listId, listName, listIndex } = e.detail || {};
        // Some product:added dispatches carry no product (or an incomplete stand-in,
        // e.g. the priority-processing checkbox's { handle: "priority-processing" }) —
        // skip those rather than send a GA4 hit with a garbage item_id.
        const rawId = product && (product.product_id ?? product.id);
        if (rawId == null) return;
        const itemId = String(rawId);

        // ctx is always { id, name, index } or null. Collection-driven adds recall it
        // from the click that led here (id/name both the collection handle, matching
        // GA4's own convention). Upsell adds are never driven by browsing that item's
        // own collection — skip recallList entirely (risk of a stale, unrelated match
        // from an earlier click on the same product elsewhere) and instead attribute
        // to the host PDP the upsell was surfaced on, when that's provided.
        let ctx = null;
        if (addSource === 'upsell') {
            if (listId || listName) {
                ctx = { id: listId, name: listName, index: listIndex };
            }
        } else {
            const recalled = recallList(itemId);
            if (recalled) ctx = { id: recalled.handle, name: recalled.name || recalled.handle, index: recalled.index };
        }

        const price = (product.price || 0) / 100;
        const qty = quantity || 1;

        // Google Ads and Merchant Center only. G-RJFJGM7P5E already gets the Google
        // & YouTube app's add_to_cart, so sending this one there would count twice;
        // the switcher flags reach GA4 on switcher_add_to_cart below instead.
        TrackGA('add_to_cart', Object.assign(switcherFlagParams(), {
            send_to: ['AW-302328870', 'MC-8V5PE7VM8Y'],
            item_list_id: ctx ? ctx.id : undefined,
            item_list_name: ctx ? ctx.name : undefined,
            value: price * qty,
            currency: window.themeVariables?.cart?.currency || 'USD',
            items: [{
                item_id: itemId,
                variant_id: product.variant_id || (variant && variant.id),
                item_name: product.product_title || product.title,
                item_variant: product.variant_title || (variant && variant.title),
                item_brand: product.vendor,
                item_category: product.product_type,
                sku: product.sku,
                index: ctx ? ctx.index : undefined,
                item_list_name: ctx ? ctx.name : undefined,
                price,
                quantity: qty,
            }],
        }));

        TrackGA4('switcher_add_to_cart', Object.assign(switcherFlagParams(), {
            product_id: itemId,
            variant_id: String(product.variant_id || (variant && variant.id) || ''),
            list_name: ctx ? ctx.name : undefined,
            quantity: qty,
            value: price * qty,
            currency: window.themeVariables?.cart?.currency || 'USD',
        }));
    });
})();